<template>
  <div class="border-gray-200 border-b bg-white z-10 flex items-center px-6">
    <!-- LOGO -->
    <a class="pt-1 flex items-center space-x-2 cursor-pointer" href="/platform">
      <div class="font-bold text-black tracking-tighter text-lg">Campflare</div>
    </a>

    <a
      :class="`px-6 text-gray-700 pt-0.5 ml-20 cursor-pointer hover:opacity-70 ${
        pathName === '/platform' ? 'text-primary' : 'text-gray-700'
      }`"
      href="/platform"
    >
      Home
    </a>

    <a
      target="_blank"
      href="https://docs-v2.campflare.com/"
      class="px-6 text-gray-700 pt-0.5 cursor-pointer hover:opacity-70"
    >
      Documentation
    </a>

    <a
      :class="`px-6 text-gray-700 pt-0.5 cursor-pointer hover:opacity-70 ${
        pathName === '/platform/reference' ? 'text-primary' : 'text-gray-700'
      }`"
      href="/platform/reference"
    >
      Legacy API Reference
    </a>
    <a
      :class="`px-6 text-gray-700 pt-0.5 cursor-pointer hover:opacity-70`"
      href="mailto:support@campflare.com"
      target="_blank"
    >
      Developer Support
    </a>

    <a
      class="ml-auto text-primary cursor-pointer hover:opacity-70"
      href="/platform/login"
      v-if="!loggedIn"
    >
      Sign up
    </a>
    <a
      class="ml-auto text-primary cursor-pointer hover:opacity-70"
      href="/platform/account"
      v-else
    >
      Account
    </a>
  </div>
</template>

<script>
const pathName = window.location.pathname;

export default {
  components: {
    // HomePage
  },
  props: ["loggedIn"],
  data: () => {
    return {
      pathName,
    };
  },
};
</script>
